import {RouteDefinition} from "../../../routes"
import {EnergyPageEditScreen} from "./EnergyPageEditScreen"

export const EnergyPageSettingsRoutes: RouteDefinition[] = [
    {
        routerLink: "/settings/energy-edit",
        component: EnergyPageEditScreen
    }
]
